module.exports = __webpack_public_path__ + "static/media/diamond_member_banner.78fae3a5.webp";